// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3pj7R","content":"Consent_content__3lktc","footer":"Consent_footer__37Y3n"};